import React from 'react'
import { connect } from 'react-redux'
import LinesEllipsis from 'react-lines-ellipsis'
import Modal from 'react-responsive-modal'
import Pagination from 'react-js-pagination'
import ReviewActions from '../../Redux/ReviewRedux'

class Reviews extends React.Component {
  constructor (props) {
    super(props)
    this.statusList = [
      { label: '- ALL STATUS -', value: '' },
      { label: 'APPROVED', value: true },
      { label: 'UNAPPROVED', value: false }
    ]
    this.state = {
      showModal: null,
      detail: {
        title: '',
        content: ''
      },
      filter: {
        page: 1,
        limit: 10,
        status: ''
      }
    }
  }

  componentDidMount () {
    this._fetchReviewList()
  }

  _fetchReviewList = (params = { ...this.state.filter }) => {
    this.props.getReviewList(params)
  }

  _filterChange = (event, field) => {
    const val = event.target.value
    let filter = { ...this.state.filter }
    filter[field] = val
    this.setState({ filter })
    this._fetchReviewList(filter)
  }

  _changePage = (page) => {
    let filter = {
      ...this.state.filter,
      page
    }
    this.setState({ filter })

    this._fetchReviewList(filter)
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
  }

  _approve = (id = null) => {
    this.props.approveReview(id)
    this._toggleModal()
  }

  render () {
    const { review } = this.props

    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3'>
            <h3 className='title mr-auto'>
              Reviews
              {
                (review.fetching || review.processing) &&
                <div className='badge badge-info ml-2'>{review.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
          </div>
          <div className='title-block'>
            <p className='title-description'>Filter:</p>

            <div className='form-inline mb-2'>
              <div className='form-group mr-2'>
                <label className='control-label mr-1'>Status</label>
                <select
                  className='form-control'
                  name='status'
                  value={this.state.filter.status}
                  onChange={(event) => this._filterChange(event, 'status')}>
                  {
                    this.statusList.map((item, i) => (
                      <option key={i} value={item.value}>{ item.label }</option>
                    ))
                  }
                </select>
              </div>
            </div>
          </div>
        </header>
        <section className='section'>
          <div className='card'>
            {
              !(review.fetching || review.processing) && review.err &&
              <div className='alert alert-danger'>{review.err}</div>
            }
            <div className='card-block table-responsive'>
              <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
                <thead>
                  <tr>
                    <th>Reviewer Name</th>
                    <th>Review Title</th>
                    <th>Review Content</th>
                    <th>Place</th>
                    <th>Status</th>
                    <th className='text-center' width='15%'>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    (review.data && review.data.list) ? review.data.list.map((item, i) => (
                      <tr key={i}>
                        <td>{ item.user.first_name } { item.user.last_name }</td>
                        <td>{ item.title || '-' }</td>
                        <td>
                          <LinesEllipsis
                            text={item.content || ''}
                            maxLine='1'
                            ellipsis='...'
                            trimRight
                            basedOn='letters'
                          />
                        </td>
                        <td>{ item.place.title || '-' }</td>
                        <td>
                          <span className={`badge badge-${item.status ? 'success' : 'danger'}`}>
                            { item.status ? 'APPROVED' : 'UNAPPROVED' }
                          </span>
                        </td>
                        <td className='text-center'>
                          <button className='btn btn-primary mr-2' title='View' onClick={() => this._selectItem(item, 'view')}>
                            <i className='fas fa-eye' />
                          </button>
                          { !item.status &&
                            <button className='btn btn-primary mr-2' title='Approve' onClick={() => this._approve(item.id)}>
                              <i className='fas fa-check' />
                            </button>
                          }
                        </td>
                      </tr>
                    ))
                      : <tr>
                        <td colSpan='8' className='text-center'>- NO DATA -</td>
                      </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>

          {/* REVIEW MODAL */}
          <Modal center open={this.state.showModal === 'view'} onClose={this._toggleModal} closeOnOverlayClick>
            <div className='section' style={{ width: '40vw' }}>
              <div className='title-block'>
                <h4 className='title mr-auto'>Review</h4>
              </div>
              <aside>
                <p>Review for <em>{this.state.detail.place ? this.state.detail.place.title : '-'}</em></p>
              </aside>
              <div className='form-group'>
                <label className='control-label'>Title</label>
                <input type='text' readOnly className='form-control' value={this.state.detail.title} />
              </div>
              <div className='form-group'>
                <label className='control-label'>Content</label>
                <textarea readOnly style={{ minHeight: '25vh' }} className='form-control' value={this.state.detail.content} />
              </div>
              <div className='form-group d-flex justify-content-end'>
                <button type='button' className='btn btn-lg btn-secondary' onClick={() => this._toggleModal()}>Close</button>
                {!this.state.detail.status && <button onClick={() => this._approve(this.state.detail.id)} className='btn btn-lg btn-primary ml-2'>Approve</button>}
              </div>
            </div>
          </Modal>
        </section>
        <section className='text-center'>
          {(review.data && review.data.total > this.state.filter.limit) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={review.data.page || this.state.filter.page}
              itemsCountPerPage={this.state.filter.limit}
              totalItemsCount={review.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  review: state.review
})

const dispatchToProps = (dispatch) => ({
  getReviewList: (filter) => dispatch(ReviewActions.reviewListRequest(filter)),
  approveReview: (id) => dispatch(ReviewActions.reviewApproveRequest(id))
})

export default connect(stateToProps, dispatchToProps)(Reviews)



// WEBPACK FOOTER //
// ./src/Pages/Attraction/Reviews.js